/** FICZERY DO FeaturesBoxSimpleBlock */

/** STANDARDOWE */

export const STANDARD_APP_FEATURES: FeatureElementData[] = [
  {
    featureIconClassName: "document-add",
    featureName: "FAKTUROWANIE",
    featureText: "Wszystkie operacje w aplikacji wykonasz szybko o każdej porze, Fakturomania posiada również integrację z KSeF."
  },
  {
    featureIconClassName: "calculator",
    featureName: "KSIĘGOWOŚĆ ONLINE",
    featureText: "Dla mikro spółek z o.o., którą bez trudu z nami poprowadzisz. Przekonaj się, że jest to możliwe i proste."
  },
  {
    featureIconClassName: "messages",
    featureName: "WSPARCIE KSIĘGOWE",
    featureText: "Nasi konsultanci są do Twojej dyspozycji. Jeżeli masz pytania dotyczące księgowości lub spółek zoo - chętnie na nie odpowiemy."
  },
  {
    featureIconClassName: "user-add",
    featureName: "PROSTY CRM",
    featureText: "System CRM usprawni kontrolę i planowanie działań w Twoim przedsiębiorstwie."
  },
  {
    featureIconClassName: "chart-bar",
    featureName: "ANALIZY FINANSOWE",
    featureText: "Dostępne pod ręką 24/7. Pełna księgowość to dokładne informacje na temat sytuacji gospodarczej twojej firmy."
  },
  {
    featureIconClassName: "download",
    featureName: "JPK i KSeF",
    featureText: "Struktury podatkowe z łatwością wygenerujesz w Fakturomanii i przekażesz je do Ministerstwa Finansów."
  }
];

/** NASZ ZESPOL */

export const NASZ_ZESPOL_FEATURES: FeatureElementData[] = [
  {
    featureIconClassName: "folder",
    featureName: "KSIĘGOWOŚĆ",
    featureText: "Dysponujemy rozległą wiedzą specjalistyczną, jak również bardzo dużym doświadczeniem w zakresie księgowości."
  },
  {
    featureIconClassName: "calculator",
    featureName: "PODATKI",
    featureText: "Na bieżąco śledzimy zmiany dotyczące ustawodastwa w zakresie mogącym mieć wpływ na funkcjonowanie przedsiębiorstwa."
  },
  {
    featureIconClassName: "clipboard",
    featureName: "SPRAWY SPÓŁKOWE",
    featureText: "Doskonale wiemy, z jakimi problemami mierzą się firmy działające w formie spółki. Specjalizujemy się w ich rozwiązywaniu."
  }
];

/** BACKGROUND_COLORS */

export const TRANSPARENT_BACKGROUND_COLOR: string = 'none';
export const GREY_BACKGROUND_COLOR: string = '#F3F5F7';


// WEBPACK FOOTER //
// ./src/constants/features-data.ts